// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsImage";
import { css } from "styled-components";

imageStyles.container = {
    gap: 5,
    css: css`
        margin: 0;
    `,
};

imageStyles.linksContainer = {
    gap: 20,
    css: css`
        padding: 0;
    `,
};

imageStyles.image = {
    css: css`
        img {
            max-height: 200px;
            width: auto;
            height: auto;
        }
    `,
};
imageStyles.productLinkItem = {
    width: 12,
};

imageStyles.externalLinkItem = {
    width: 12,
};
